import React from 'react';
import Trip from '../Components/AddTripForm/Trip';

const AddTrip = ({onSaveTrip, onCancelEdit}) => {
  return (
    <div>
    <Trip onSaveTrip={onSaveTrip} onCancelEdit={onCancelEdit}/>
    </div>
  );
};

export default AddTrip;
